<ul class="json-list">
  <ng-container
    *ngTemplateOutlet="
      recursiveList;
      context: { $implicit: data }
    "></ng-container>
</ul>

<ng-template #recursiveList let-data>
  <ul *ngFor="let key of objectKeys(data)" class="json-list">
    <li>
      <ng-container *ngIf="isObject(data[key]); else primitiveValue">
        <span
          class="collapsible-key"
          (click)="toggle(key)"
          (keydown)="onKeyDown($event, key)"
          tabindex="0"
          role="button"
          title="Toggle">
          <span class="toggle-arrow">{{ isOpen(key) ? '▼' : '▶' }}</span>
          <span class="key" [innerHTML]="key"></span>
          <span class="type-label">{{ getType(data[key]) }}</span>
        </span>

        <ul *ngIf="isOpen(key)" class="nested-list">
          <ng-container
            *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: data[key] }
            "></ng-container>
        </ul>
      </ng-container>

      <ng-template #primitiveValue>
        <span class="key" [innerHTML]="key + ':'"></span>
        <span [ngClass]="getType(data[key])" class="value">
          <ng-container *ngIf="getType(data[key]) === 'string'"
            >"{{ data[key] }}"</ng-container
          >
          <ng-container *ngIf="getType(data[key]) === 'null'"
            >null</ng-container
          >
          <ng-container
            *ngIf="
              getType(data[key]) !== 'null' && getType(data[key]) !== 'string'
            "
            >{{ data[key] }}</ng-container
          >
        </span>
      </ng-template>
    </li>
  </ul>
</ng-template>
